import type { LayoutDataType } from '../../types';

export const TOPICS_OPTIONS: {
  title: string;
  id: NonNullable<LayoutDataType['topics']>;
}[] = [
  {
    title: '🫂 Support & Care',
    id: 'support',
  },
  {
    title: '❤️ Flirt & Romance',
    id: 'romantic',
  },
  {
    title: '💬 Intelligent Talks',
    id: 'talks',
  },
  {
    title: '🎭 Roleplay',
    id: 'roleplay',
  },
  {
    title: '🧠 Exploring AI potential',
    id: 'explore-ai',
  },
];
